import KeenTracking from 'keen-tracking';

function install(Vue, options) {
  const KeenHelpers = KeenTracking.helpers;
  const KeenUtils = KeenTracking.utils;
  const Keen = new KeenTracking({
    projectId: options.projectId,
    writeKey: options.writeKey,
  });

  if (options.debug) {
    KeenTracking.debug = true;
  }

  if (options.autoTracking) {
    Keen.initAutoTracking(options.autoTracking);
  }

  if (options.trackRoutes) {
    if (typeof options.trackRoutes === 'object') {
      if (options.trackRoutes.onRouteChange) {
        options.trackRoutes.router.afterEach((to) => {
          Keen.recordEvent(options.router(to));
        });
      } else {
        options.trackRoutes.router.afterEach((to) => {
          Keen.recordEvent(`Navigate to ${to.name || to.path}`);
        });
      }
    } else {
      throw new Error('Router configuration invalid');
    }
  }

  if (options.trackVuex && options.trackVuex.mutations) {
    options.trackVuex.store.subscribe((mutation) => {
      Keen.recordEvent(mutation.type);
    });
  }

  if (options.trackVuex && options.trackVuex.actions) {
    options.trackVuex.store.subscribeAction((action) => {
      Keen.recordEvent(action.type);
    });
  }

  // eslint-disable-next-line new-cap
  const cookie = new KeenUtils.cookie('keen');
  const domainName = KeenHelpers.getDomainName(window.location.hostname);
  const cookieDomain = domainName && options.shareUuidAcrossDomains ? {
    domain: `.${domainName}`,
  } : {};

  let uuid;
  if (options.collectUuid) {
    uuid = cookie.get('uuid');
    if (!uuid) {
      uuid = KeenHelpers.getUniqueId();
      cookie.set('uuid', uuid, cookieDomain);
    }
  }

  Keen.extendEvents(() => ({
    page: {
      title: document.title,
      url: document.location.href,
      info: {
        /* Enriched */
      },
    },
    referrer: {
      url: document.referrer,
      info: {
        /* Enriched */
      },
    },
    tech: {
      browser: KeenHelpers.getBrowserProfile(),
      // eslint-disable-next-line no-template-curly-in-string
      user_agent: '${keen.user_agent}',
      info: {
        /* Enriched */
      },
    },
    time: KeenHelpers.getDatetimeIndex(),
    keen: {
      addons: [
        {
          name: 'keen:ua_parser',
          input: {
            ua_string: 'tech.user_agent',
          },
          output: 'tech.info',
        },
        {
          name: 'keen:url_parser',
          input: {
            url: 'page.url',
          },
          output: 'page.info',
        },
        {
          name: 'keen:referrer_parser',
          input: {
            referrer_url: 'referrer.url',
            page_url: 'page.url',
          },
          output: 'referrer.info',
        },
      ],
    },
    user: {
      uuid,
    },
  }));

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$keen = Keen;
}

export default { install };
